import {RootState} from "../../store";

export const requestResultSelector = (state: RootState) => {
    return state.resetPassword.records.requestResult;
};

export const confirmResultSelector = (state: RootState) => {
    return state.resetPassword.records.confirmResult;
};
